import { Badge } from "@/components/ui/badge";
import { ShieldAlert, FolderKanban } from "lucide-react";

export function TipoBadge({ tipo, className = "" }) {
  const isInstr = tipo === "instrucao";
  const Icon = isInstr ? ShieldAlert : FolderKanban;
  return (
    <Badge data-testid="tipo-badge" className={`gap-1 ${isInstr ? "bg-amber-500/20 text-amber-300 border-amber-500/40" : "bg-sky-500/20 text-sky-300 border-sky-500/40"} ${className}`}>
      <Icon className="h-3 w-3" />{isInstr ? "Instrução" : "Curso"}
    </Badge>
  );
}
